import {Component, Input, OnInit} from '@angular/core';
import {RxComponent} from '../../../core/components/common/rx.component';

declare var moment: any;

@Component({
    selector: 'itpx-proceed-details',
    templateUrl: './proceed-details.component.html',
    styleUrls: ['./proceed-details.component.css']
})
export class ProceedDetailsComponent extends RxComponent implements OnInit {

    @Input('data') data = null;

    public settlement: any;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.settlement = this.data.batchItem;
    }

    getFormattedDate(date) {
        return date ? moment(date).format('DD-MM-YYYY') : false;
    }

    getDaysFromSettlement() {
        if (this.settlement &&
            this.settlement.orderDate) {
            const end = moment(new Date(this.settlement.orderDate)).add(30, 'days');
            return end.diff(new Date(), 'days') || 0;
        }
    }

    formatPrice(price) {
        return price.toFixed(2);
    }

    isSettlementPending() {
        return this.settlement &&
            this.settlement.settlementBatchDTO &&
            this.settlement.settlementBatchDTO.status.configKey === 'pending';
    }

    isSettlementSettled() {
        return this.settlement &&
            this.settlement.settlementBatchDTO &&
            (this.settlement.settlementBatchDTO.status.configKey === 'settled' ||
            this.settlement.settlementBatchDTO.status.configKey === 'parked') ||
            this.settlement.settlementBatchDTO.status.configKey === 'settlement-pending';
    }

    getDetailsClass() {
        return this.isSettlementPending() ? 'col-md-12' : 'col-md-9';
    }

    getPaymentProcessingFeeAmount() {
        return this.settlement.transactionDetails.itemCurrency && this.settlement.transactionDetails.paymentProcessingFeeAmount ?
            this.settlement.transactionDetails.itemCurrency + ' ' + this.settlement.transactionDetails.paymentProcessingFeeAmount: 0;
    }

    getConversionFeeAmount() {
        return this.settlement.transactionDetails.itemCurrency && this.settlement.transactionDetails.conversionFeeAmount ?
            this.settlement.transactionDetails.itemCurrency + ' ' + this.settlement.transactionDetails.conversionFeeAmount: 0;
    }

    getPlatformFeeAmount() {
        return this.settlement.settlementCurrency && this.settlement.transactionDetails.platformFeeAmount?
            this.settlement.settlementCurrency + ' ' + this.settlement.transactionDetails.platformFeeAmount: 0;
    }

    getSellerProceedAmount() {
        return this.settlement.settlementCurrency && this.settlement.settlementAmount ?
            this.settlement.settlementCurrency + ' ' + this.settlement.settlementAmount: 0;
    }

    getSellerSurchargesAmount() {
        return this.settlement.settlementCurrency && this.settlement.transactionDetails.sellerSurchargesInSellerCurrency ?
            this.settlement.settlementCurrency + ' ' + this.settlement.transactionDetails.sellerSurchargesInSellerCurrency: 0;
    }

    getNetOrderValue() {
        if (this.settlement.settlementCurrency && this.settlement.transactionDetails.itemCurrency
            && this.settlement.transactionDetails.orderNetValueInOrderCurrency && this.settlement.transactionDetails.orderNetValueInSettlementCurrency) {
            let sellerCurrencyEqualsBuyer = this.settlement.settlementCurrency == this.settlement.transactionDetails.itemCurrency;
            return sellerCurrencyEqualsBuyer ? this.settlement.settlementCurrency + ' ' + this.settlement.transactionDetails.orderNetValueInSettlementCurrency :
                this.settlement.transactionDetails.itemCurrency + ' ' + this.settlement.transactionDetails.orderNetValueInOrderCurrency + ' / '
                + this.settlement.settlementCurrency + ' ' + this.settlement.transactionDetails.orderNetValueInSettlementCurrency
        }
        return null;

    }
}





// WEBPACK FOOTER //
// ./src/app/shared/components/settlement-proceeds-details/proceed-details.component.ts